<!--
 * @Author: jixiaoyong
 * @Email: jixiaoyong1995@gmail.com
 * @Date: 23/07/29
 * @LastEditors: jixiaoyong
 * @LastEditTime: 24/05/30
 * @FilePath: /app_list/src/components/EditorPage.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by jixiaoyong, All Rights Reserved. 
-->
<script setup>
import { updateFileToGithub } from "@/utils/github_api_util";
import { checkUrlValid, compareVersion, findNameByLink, getVersion } from "@/utils/util";
import SwitchButton from '@/wigets/SwitchButton.vue';
import { Octokit } from "@octokit/core";
import axios from 'axios';
import Cookies from 'js-cookie';
import { computed, onMounted, ref, watch } from 'vue';


const options = ref([]);
const githubToken = ref(Cookies.get('token') || "");
const selectedOption = ref('');
const autoMatchSelected = ref('true' === Cookies.get('isAutoMatch'))
const newLink = ref()
const updating = ref(false)
const errorMsg = ref('')

const octokit = computed(() => {
  return new Octokit({
    auth: githubToken.value ?? ""
  })
})

onMounted(async () => {
  try {
    const response = await axios.get('/config.json');
    options.value = response.data.data;
    for (let option of options.value) {
      option.version = getVersion(option.link)
    }
    selectedOption.value = options.value[0];
  } catch (error) {
    console.error('读取配置文件失败：', error);
  }
});

function matchLinkAndSelectedOption() {
  const currentLinkName = newLinkName.value
  if (currentLinkName) {
    selectedOption.value = options.value.find((option) => { return option.name === currentLinkName }) ?? selectedOption.value
  }
}

const newLinkName = computed(() => {
  let newLinkValue = newLink.value
  if (!newLinkValue) {
    return '未知'
  }
  return findNameByLink(options.value, newLinkValue)
})


watch(autoMatchSelected, (newVal, oldVal) => {
  Cookies.set('isAutoMatch', newVal, { expires: 365 })
  if (newVal) {
    matchLinkAndSelectedOption()
  }
})

watch(newLink, (newVal, _oldVal) => {
  console.log("newVal:", newVal)
  if (newVal && autoMatchSelected.value) {
    matchLinkAndSelectedOption()
  }
})

const newLinkVersion = computed(() => {
  if (!newLink.value) {
    return 'v0.0.0'
  }
  return getVersion(newLink.value)
})

const updateConfig = async () => {
  updating.value = true
  // 更新 config.json 的逻辑代码
  const commitMsg = `feat: 更新 ${selectedOption.value.name} 为 ${getVersion(newLink.value)}`

  options.value.forEach(option => {
    if (option.name === selectedOption.value.name) {
      option.link = newLink.value.trim();
    }
  });
  const dataObject = {
    data: options.value
  };
  const jsonString = JSON.stringify(dataObject, null, 2);
  const fileBase64 = btoa(unescape(encodeURIComponent(jsonString)));

  console.log("jsonString" + jsonString + "\n\n\n\nencodedString \n" + "\n\n\n\nbase64:" + fileBase64)
  errorMsg.value = ""

  updateFileToGithub(octokit.value, fileBase64, commitMsg).then(() => {
    updating.value = false
    Cookies.set('token', githubToken.value, { expires: 90 });
    alert("更新成功😊")
  }).catch((error) => {
    updating.value = false
    console.log(error)
    errorMsg.value = JSON.stringify(error, null, 2)
    alert("更新失败☹️", errorMsg.value)
  })

};

const isTokenVaild = computed(() => {
  const token = githubToken.value
  if (!token || 93 != token.length) {
    return false
  }
  if (!token.startsWith('github_')) {
    return false
  }

  return true
})

const buttonEnable = computed(() => {
  if (!isTokenVaild.value || updating.value) {
    return false;
  }

  let newLinkValue = newLink.value

  if (!newLinkValue || 0 == newLinkValue.trim().length) {
    return false;
  }

  newLinkValue = newLinkValue.trim()

  if (!checkUrlValid(newLinkValue)) {
    return false
  }

  if (compareVersion(newLinkValue, selectedOption.value.link) < 0) {
    return false;
  }

  if (newLinkName.value != selectedOption.value.name) {
    return false
  }

  if (newLink.value === selectedOption.value.link) {
    console.log('链接完全一样，没有必要更新')
    return false
  }

  return true
})


function onAutoMatchToggle(isOpen) {
  autoMatchSelected.value = isOpen
}
</script>

<template>

  <main>
    <div class="title-bar">
      <button class="back-button" onclick="history.back()">返回</button>
      <h1 class="title">在线更新 APP 链接</h1>
    </div>
    <div class="update-config-container">
      <div style="width: 100%;text-align:start">GitHub token:</div>
      <input v-model="githubToken" type="text" placeholder="请输入GitHub token" />
      <SwitchButton :value="autoMatchSelected" label="自动匹配链接和 APK" :onToggle="onAutoMatchToggle" />

      <div class="radio-group">
        <label v-for="option in options" :key="option.name"
          :class="{ 'selected': option.name === selectedOption.name }">
          <input type="radio" :value="option" v-model="selectedOption" />
          {{ option.name }}{{ option.version }}
        </label>
      </div>
      <div style="width: 100%;text-align:start">APK 最新下载链接：<span style="color: red;font-weight:bold">{{
        !newLink || checkUrlValid(newLink.trim()) ? "" : "链接不合法"
          }}</span>
      </div>
      <input v-model="newLink" type="text" placeholder="请输入下载链接" />

      <div class="link-version"> 将 <span class="version">{{ selectedOption.name }}</span> 从 <span class="version">{{
        selectedOption.version }}</span> 更新为 <span class="version">{{ newLinkName
          }} </span> <span class="version"> {{ newLinkVersion }}</span>
      </div>

      <button @click="updateConfig" v-bind:disabled="!buttonEnable">确认更新</button>
    </div>

    <div v-if="errorMsg" style="width: 90%; margin-top:5%">{{ errorMsg }}</div>
  </main>
</template>

<style scoped>
.update-config-container {
  max-width: 90%;
  margin: 0 5%;
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: center
}

.radio-group {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 20px 0;
  gap: 20px;
  width: 95%;
  box-sizing: border-box;
}

.radio-group label {
  flex: 1 1 auto;
  min-width: 200;
  text-align: center;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ddd;
  cursor: pointer;
}

.selected {
  background-color: #007aff;
  color: #fff;
  font-size: large;
  font-weight: bold;
}

.radio-group input[type="radio"] {
  display: none;
}

.radio-group input[type="radio"]:checked+label {
  background-color: #007aff;
  color: white;
}

input,
button {
  width: 100%;
  padding: 10px;
  margin: 20px 0;
  border-radius: 5px;
  border: 1px solid #ddd;
  box-sizing: border-box;
}

button {
  background-color: #007aff;
  color: white;
  font-weight: bold;
  cursor: pointer;
}

button:disabled {
  background-color: #ddd;
}

button:not([disabled]):hover {
  background-color: #0051a8;
}

.link-version {
  font-size: large;
  font-weight: bold;
  width: 100%;
  text-align: start;
}

.link-version .version {
  color: #007aff;
  font-weight: bolder;
}

.title-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 5%;
}

.back-button {
  position: absolute;
  width: 10%;
  left: 0;
  margin-left: 8px;
  padding: 8px;
  font-size: 16px;
  color: #007aff;
  transition: background-color 0.3s ease;
  background: none;
  border: none;
  cursor: pointer;
}

.title-bar .back-button:hover {
  background-color: #e6f0fa;
  color: #0056b3;
}

.title {
  font-size: 17px;
  font-weight: bold;
  color: #000;
  text-align: center;
}


@media (max-width: 600px) {
  .title-bar {
    padding: 8px;
  }

  .back-button {
    padding: 4px 8px;
    font-size: 14px;
  }

  .title {
    font-size: 15px;
  }
}
</style>
